export default function install(Vue, options) {
  var vm = new Vue({
    data: {
      menuItems: [],
      headerTitle: {
        title: ""
      }
    }
  });

  Object.defineProperties(Vue.prototype, {
    $menuItems: {
      get: function() {
        return vm.menuItems;
      },
      set: function(value) {
        vm.menuItems = value;
        return this;
      }
    },
    $headerTitle: {
      get: function() {
        return vm.headerTitle;
      },
      set: function(value) {
        vm.headerTitle = value;
        return this;
      }
    }
  });
}



//////////////////
// WEBPACK FOOTER
// ./Helpers/Plugins/menuItems.js
// module id = null
// module chunks = 